<ion-content [fullscreen]="true">
  <ion-header *ngIf="showToolbar">
    <ion-toolbar>
      <ion-title size="default">Family Members</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">
          <ion-icon name="close" size="large"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <div class="page-container">
    <br><br>
    <ion-button *ngIf="isFamilyMember === true" expand="full" size="medium" (click)="addFamilyMember()">
      Add Family Member
    </ion-button>

    <ion-list lines="none">
      <ion-item-sliding *ngFor="let member of lstFamily">
        <ion-item lines="full">
          <ion-avatar slot="start">
            <img *ngIf="member.ImageSrc" alt="Family Member" class="largerImage" [src]="member.ImageSrc">
            <img *ngIf="!member.ImageSrc" alt="Family Member" class="largerImage" src="assets/images/default.png">
          </ion-avatar>
          <ion-label>
            <a *ngIf="isFamilyMember === true || userService.currentUser?.IsAdministrator === true"
              (click)="showFamilyMember(member)">{{member.ProfileName}}</a>
            <b
              *ngIf="isFamilyMember === false && userService.currentUser?.IsAdministrator !== true">{{member.ProfileName}}</b>
            <br>
            {{member.RelationTypeName}}<br>
            <span class="space-between">
              <a href="tel:{{member.Mobile1}}">{{member.Mobile1}}</a>
              <a [href]="'sms:'+ member.Mobile1 | safeUrl">
                <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
              </a>
            </span>
            <a href="mailto:{{member.PrimaryEmail}}">{{member.PrimaryEmail}}</a>
          </ion-label>
        </ion-item>
        <ion-item-options>
          <ion-item-option *ngIf="isFamilyMember === true" color="danger" (click)="deleteFamilyMember(member)"><ion-icon
              name="trash-outline"></ion-icon></ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    </ion-list>
  </div>
</ion-content>